import React from "react";
import logo from "../images/LogoVertDuos.svg";
import logoXyz from "../images/LogoVertDuosXyz.svg";
import phone from "../images/IconPhone.svg";
import { ENV } from "../config/ApiConfig";

class Header extends React.Component {
  render() {
    return (
      <div
        data-collapse="medium"
        data-animation="default"
        data-duration="400"
        data-doc-height="1"
        role="banner"
        className="nav member w-nav"
      >
        <div className="nav-inner">
          <div className="nav-logo-wrap w-clearfix">
            <a href="https://www.getduos.com" className="brand w-nav-brand">
              <img src={ENV === "prod" ? logo : logoXyz} width="120" alt="" className="image-5 mobile" />
            </a>
          </div>
          <div className="nav-menu-wrap">
            <div className="menu-button w-nav-button">
              <div className="menu-icon w-icon-nav-menu"></div>
            </div>
            <div className="phonenumber">
              <a href="tel:8552129242" className="link-block-3 w-inline-block">
                <img src={phone} loading="lazy" alt="" className="iconphone" />
              </a>
              <a href="tel:8552129242" className="nav-link phone mobile w-nav-link">
                855 212 9242
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
